<template>
<div>
    <b-img center class="screenshot" :src="screenshotURL" />
 
    <div class="timestamp"><b-icon icon="arrow-clockwise"/>{{ screenshotTimestamp }}</div>
   
    <t-button-group>
        <t-button icon='arrow-clockwise' @click="refresh" :disabled="loader">{{ $t('button.refresh') }}</t-button> 
    </t-button-group>

    <RequestInfo :ok="ok" :error="error" :loader="loader"/>
</div>
</template>

<script>
import infopoint from '@/store/displays/infopoint'

export default {
    props: ['item'],
    data() {
        return {
            ok: false,
            error: false,
            loader: false,
            defaultImage: "/traveller-ui/static/traveller/img/not-found-960x540.png",
            screenshotUpdater: null
        }
    },
    computed: {
        infopoint() {
            return this.item;
            //return this.$store.state.infopoint.selectedInfopoint;
        },
        screenshots() {
            return this.$store.state.infopoint.screenshots;
        },
        screenshotURL(){
            var screenshot = this.defaultImage;
            if(this.infopoint){
                var iScreenshot = this.screenshots[/*this.infopoint.uniqueId*/ this.infopointId];
                if(iScreenshot && iScreenshot.base64)
                    screenshot =  iScreenshot.base64    
            }
     
            return screenshot;
        },
        screenshotTimestamp(){
            var timestamp = "-";
            if (this.infopoint && this.screenshots[/*this.infopoint.uniqueId*/ this.infopointId]){
                 timestamp = this.screenshots[/*this.infopoint.uniqueId*/ this.infopointId].timestamp;
                 if(!timestamp) timestamp = "-";
            }
            return timestamp;
        },

        infopointId(){
            var id;
            if(this.infopoint){
                // id =  this.infopoint.infopointLabel ?  this.infopoint.infopointLabel : this.infopoint.uniqueId;
                id = this.infopoint.uniqueId;
            } 
            return id;
        }

    },
    watch: {
        infopoint(){
            this.ok = this.error = this.loader = false;
            // screenshot ??
           // console.log("infopoint")
            //clearTimeout(this.screenshotUpdater);
            this.updateScreenshot();
           
        } 
    },
    beforeCreate: function() {
        if (!this.$store.state.infopoint) {
          this.$store.registerModule("infopoint", infopoint);
        }
      },
    methods: {
        refresh(){
            this.ok = this.error = false;
            this.loader = true;
            const self = this;
            this.$store.dispatch('infopoint/sendCaptureRequest', /*this.infopoint.uniqueId*/ this.infopointId );
        
            setTimeout(() => { self.ok = true; self.loader = false; }, 1000);               
        },

        updateScreenshot(){
            clearTimeout(this.screenshotUpdater);
            if(this.infopoint)
                this.$store.dispatch('infopoint/getScreenshot', /*this.infopoint.uniqueId*/  this.infopointId );

            this.screenshotUpdater = setTimeout(this.updateScreenshot, 5000)
        },

    },
    created(){
        this.updateScreenshot();
    },
    beforeDestroy(){
        clearTimeout(this.screenshotUpdater);
    }
    
}

</script>

<style scoped lang="scss">
.screenshot {
    border: 1px solid #6c757d;
    border: 1px solid #dee2e6;
    border: 2px solid #000;
}
.timestamp {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    
    border: 1px solid #6c757d;
    border: 1px solid #dee2e6;
    border: 2px solid #000;


    border-top: 0;
    padding: 4px 10px 2px 10px;
    margin-top: -1px;
  
    text-align: center;

    color:  #000;

    display: inline-block;

    border-radius: 0 0 3px 3px;

    background-color: rgba(0, 0, 0, 0.05);
}

.timestamp svg {
    margin-right: 8px;
}

</style>
